<template>
  <el-container>
    <main class="page__container">
      <div class="container">
        <h2 class="page__title">
          Мониторинг
        </h2>
        <div
          v-loading="cameraStatisticsLoading"
          class="cameras-statistics"
        >
          <div
            v-for="item in cameraStatisticsItems"
            :key="item.status"
            class="cameras-statistics__item"
          >
            <span class="cameras-statistics__label">{{ item.label }}</span>
            <strong class="cameras-statistics__value">{{ cameraStatistics[item.status] }}</strong>
            <i :class="[statuses[item.status].icon, 'cameras-statistics__icon']" />
          </div>
        </div>
      </div>
    </main>
  </el-container>
</template>

<script>
import { ApiService } from "@/api";
import statuses from "@/components/Cameras/cameraStatuses";

export default {
  name: "CamerasMonitoring",
  data() {
    return {
      cameraStatisticsLoading: false,
      cameraStatistics: {
        online: 0,
        offline: 0,
        error: 0,
      },
      cameraStatisticsItems: [
        { status: "online", label: "Камер работает" },
        { status: "offline", label: "Камер отключено" },
        { status: "error", label: "Проблемы с потоком" },
      ],
      statuses,
    };
  },
  created() {
    this.loadCameraStatistics();
  },
  methods: {
    loadCameraStatistics() {
      this.cameraStatisticsLoading = true;
      return ApiService.cameras
        .getStatistics()
        .then(({ online, offline, error }) => {
          this.cameraStatistics = {
            online,
            offline,
            error,
          };
        })
        .catch(() => undefined)
        .finally(() => (this.cameraStatisticsLoading = false));
    },
  },
};
</script>

<style lang="postcss">
.cameras-statistics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 24px;
}
.cameras-statistics__item {
  position: relative;
  min-width: 0;
  padding: 16px 44px 16px 16px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: #fff;
}
.cameras-statistics__label {
  display: block;
  margin-bottom: 6px;
  color: #909399;
  font-size: 13px;
}
.cameras-statistics__value {
  color: #303133;
  font-size: 24px;
  line-height: 1.2;
}
.cameras-statistics__icon {
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 16px;
}
@media (max-width: 640px) {
  .cameras-statistics {
    grid-template-columns: 1fr;
  }
}
</style>
